<script>
import Multiselect from "@vueform/multiselect";
import "@vueform/multiselect/themes/default.css";

import Layout from "../../layouts/main";
import appConfig from "../../../app.config";
// import PageHeader from "@/components/page-header";

import { customers, deleteCustomer  } from "@/service";
import { formatDatetime } from "@/helpers/common";
import _ from 'lodash';
import addCustomer from "@/views/customer/components/add-customer";
import tableLoading from "@/views/widgets/table-loading";
import ShowAvatar from "@/views/widgets/show-avatar";
import {CUSTOMER_INDUSTRY_LIST} from "@/config/common";
import {alertComfirm, successMsg} from "@/helpers/swal";
import LocationSelect from "@/views/widgets/location-select";
import i18n from "@/i18n";
const industryOptions = [{value: '', label: i18n.global.t('page.all')}, ...CUSTOMER_INDUSTRY_LIST]


export default {
  page: {
    title: i18n.global.t('menu.business-partner.customer'),
    meta: [{
      name: "description",
      content: appConfig.description,
    },],
  },
  data() {
    return {
      title: this.$t('menu.business-partner.customer'),
      items: [{
        text: this.$t('menu.business-partner.text'),
        href: "/",
      },
        {
          text: this.$t('menu.business-partner.customer'),
          active: true,
        },
      ],
      /* 分页start */
      tab_info_length: 0,
      page: 1,
      perPage: 10,
      prePageOption: [10, 20, 30, 40, 50],
      pages: [],
      /* 分页end */
      config: {
        altFormat: "Y-m-d",
        altInput: true,
        dateFormat: "Y-m-d",
        mode: "range",
        clearButton: true,
      },
      date2: null,
      tableHeaders: [
        {
          name: 'name',
          label: this.$t('page.work-order.customer-name'),
          visible: true
        },
        {
          name: 'code',
          label: this.$t('page.customer-attr.code'),
          visible: true
        },
        {
          name: 'industry',
          label: this.$t('page.industry'),
          visible: true
        },
        {
          name: 'attribute',
          label: this.$t('base.attribute'),
          visible: true
        },
        // {
        //   name: 'contact_name',
        //   label: '联系人',
        //   visible: true
        // },
        {
          name: 'tel',
          label: this.$t('page.contact_number'),
          visible: true
        },
        {
          name: 'email',
          label: this.$t('page.email'),
          visible: true
        },
        {
          name: 'location',
          label: this.$t('page.location'),
          visible: true
        },
        {
          name: 'address',
          label: this.$t('page.detailedAddress'),
          visible: true
        },
        {
          name: 'register_status',
          label: this.$t('page.registerStatus'),
          visible: true
        },
        {
          name: 'register_at',
          label: this.$t('page.register_time'),
          visible: true
        }
      ],
      showAllColumns: [],
      tableLoading: false,
      tableLoaded: false,
      dataList: [],
      count: 0,
      filters: {
        page: 1,
        page_size: 2,
      },
      filter_value: {
        keyword: '',
        industry: null,
        country: null,
        province: null,
        city: null,
        register_at: null,
        register_status: undefined
      },
      CUSTOMER_INDUSTRY_LIST,
      industryOptions,
      registerStatusOptions: [
        {
          label: this.$t('page.all'),
          value: undefined,
        },
        {
          label: this.$t('page.registered'),
          value: 1
        },
        {
          label: this.$t('page.unregistered'),
          value: 0
        }
      ]
    };
  },
  components: {
    Layout,
    // PageHeader,
    Multiselect,
    addCustomer,
    tableLoading,
    ShowAvatar,
    LocationSelect,
  },
  computed: {

  },
  watch: {

  },
  mounted() {
    this._getFirstPage()
  },

  methods: {
    formatDatetime,
    // 设置显示列
    changeShowAllColumns() {
      console.log(this.showAllColumns)
      this.tableHeaders.forEach(i => {
        i.visible = this.showAllColumns
      })
    },
    /* 设置分页选项 */
    setPages() {
      this.pages = [];
      this.tab_info_length = this.count;
      let numberOfPages = Math.ceil(this.count / this.perPage);
      for (let index = 1; index <= numberOfPages; index++) {
        this.pages.push(index);
      }
    },
    // 去权限管理页面
    goPermission() {
      this.$router.push({
        path: '/permission-management',
        query: {
          type: 'customer'
        }
      })
    },
    // 新建工单
    add() {
      this.$refs.addCustomer.open()
    },
    // 筛选
    doFilter () {
      this.orders = []
      const search = {
        keyword: null,
        industry: null,
        country: null,
        province: null,
        city: null,
        register_status: null,
        register_at_after: null,
        register_at_before: null
      }
      if (this.filter_value.keyword) {
        search['keyword'] = this.filter_value.keyword
      }
      if (this.filter_value.industry) {
        search['industry'] = this.filter_value.industry
      }
      if (this.filter_value.country) {
        search['country'] = this.filter_value.country
      }
      if (this.filter_value.province) {
        search['province'] = this.filter_value.province
      }
      if (this.filter_value.city) {
        search['city'] = this.filter_value.city
      }
      if (this.filter_value.register_status !== null) {
        search['register_status'] = this.filter_value.register_status
      }
      if (this.filter_value.register_at) {
        const [start, end] = this.filter_value.register_at.split(' 至 ')
        search['register_at_after'] = start
        search['register_at_before'] = end
      }

      this.filters = _.assign(this.filters, search)
      this._getFirstPage()
    },
    // 重置
    resetSearch() {
      this.filter_value.keyword = null
      this.filter_value.industry = null
      this.filter_value.country = null
      this.filter_value.province = null
      this.filter_value.city = null
      this.filter_value.register_status = null
      this.filter_value.register_at = null
      this.$refs.locationFilter.clear()
      this.doFilter()
    },
    // 翻页
    pageChange(val) {
      this.filters.page = val
      this._getList()
    },
    // 设置每页条数
    pageSizeChange(val) {
      this.filters.page_size = val
      this._getFirstPage()
    },
    // 获取数据
    _getFirstPage() {
      this.filters.page = 1;
      this._getList()
    },
    _getList() {
      this.filters.page_size = this.perPage
      this.tableLoading = true
      this.tableLoaded = false
      customers(this.filters).then(res => {
        this.tableLoading = false
        this.tableLoaded = true
        this.dataList = res.payload.results
        this.count = res.payload.count
        this.setPages()
      }).catch(err => {
        console.log(err)
      })
    },
    deleteItem(id) {
      alertComfirm().then(res => {
        if (res) {
          deleteCustomer(id).then(res => {
            if (res.meta.code == 200) {
              successMsg(this.$t('base.delete_success'))
              this._getFirstPage()
            }
          })
        }
      })
    },
    locationTxt(item) {
      let txt = ''
      if (item.country_txt) {
        txt += item.country_txt
      }
      if (item.province_txt) {
        txt += '-' + item.province_txt
      }
      if (item.city_txt) {
        txt += '-' + item.city_txt
      }
      return txt
    },
    locationSelected(selected) {
      if (selected) {
        this.filter_value.country = selected[0]
        this.filter_value.province = selected[1]
        this.filter_value.city = selected[2]
      } else {
        this.filter_value.country = null
        this.filter_value.province = null
        this.filter_value.city = null
      }
    }

  },
};
</script>

<template>
  <Layout>
<!--    <PageHeader :title="title" :items="items" />-->
    <b-row>
      <b-col lg="12">
        <b-card no-body id="orderList">
          <b-card-header class="border-0">
            <b-row class="align-items-center gy-3">
              <b-col cols="sm">
                <h5 class="card-title mb-0">{{this.$t('menu.business-partner.customer')}}</h5>
              </b-col>
              <b-col sm="auto">
                <div class="d-flex gap-1 flex-wrap">
                  <b-button type="button" variant="outline-primary" class="add-btn me-1" v-perm="'admin.permission.get'" @click="goPermission">
                    {{ $t('page.permission-management') }}
                  </b-button>
                  <b-button type="button" variant="primary" class="add-btn" @click="add">
                    <i class="ri-add-line align-bottom me-1"></i> {{this.$t('base.add')}}
                  </b-button>
                </div>
              </b-col>
            </b-row>
          </b-card-header>
          <b-card-body class="border border-dashed border-end-0 border-start-0 mb-3">
            <b-form>
              <b-row class="g-3">
                <b-col xxl="2">
                  <div class="search-box h-100">
                    <input type="text" class="form-control search h-100" v-model="filter_value.keyword"
                           :placeholder="`${this.$t('page.work-order.customer-name')}/${this.$t('page.contact_phone')}/${this.$t('page.email')}`" />
                    <i class="ri-search-line search-icon"></i>
                  </div>
                </b-col>
                <b-col xxl="2">
                  <div class="input-light h-100">
                    <Multiselect class="form-control h-100" :placeholder="this.$t('page.select-industry')" v-model="filter_value.industry" :close-on-select="true" :searchable="false"
                                 :create-option="false" :options="industryOptions" :can-clear="false" />
                  </div>
                </b-col>
                <b-col xxl="2">
                  <div class="input-light">
                    <location-select ref="locationFilter" @selected="locationSelected"></location-select>
                  </div>
                </b-col>
                <b-col xxl="2">
                  <div  class="d-flex align-items-center flex-grow-1 h-100">
                    <!--                    <p class="ms-2 me-1 search-title mb-0">-->
                    <!--                      {{ `${this.$t('page.create_time')}:` }}-->
                    <!--                    </p>-->
                    <div style="width:100%" class="position-relative h-100">
                      <flat-pickr
                        :placeholder="$t('page.selectRegisterTime')"
                        v-model="filter_value.register_at"
                        :config="config"
                        class="form-control flatpickr-input h-100"
                      >
                      </flat-pickr>
                      <!--                      <span v-if="dateValue" @click="clearDate" class="multiselect-clear-icon position-absolute cursor-pointer" style="bottom: 26%; right:1rem;"></span>-->
                    </div>
                  </div>
                </b-col>
                <b-col xxl="2">
                  <div class="input-light">
                    <el-select
                      v-model="filter_value.register_status"
                      filterable
                      style="width: 100%; line-height: 37.5px"
                      size="large"
                      :placeholder="this.$t('page.selectRegisterStatus')"
                    >
                      <el-option
                        v-for="(option, index) in registerStatusOptions"
                        :label="option['label']"
                        :value="option['value']"
                        :key="index"
                      ></el-option>
                    </el-select>
                  </div>
                </b-col>
                <b-col xxl="2"  class="d-flex justify-content-end align-items-end align-self-center">
                    <b-button type="button" variant="primary" class="me-2" @click="doFilter">
                      <i class="ri-search-line me-1 align-bottom"></i>
                      {{this.$t('search')}}
                    </b-button>
                    <b-button
                        type="button"
                        variant="info"
                        @click="resetSearch"
                    >
                      <i class="ri-restart-line me-1 align-bottom"></i>
                      {{this.$t('base.reset')}}
                    </b-button>
                </b-col>
              </b-row>
            </b-form>
          </b-card-body>
          <b-card-body class="pt-0">
            <div>
              <div class="table-responsive table-card mb-1">
                <table class="table table-nowrap align-middle" id="orderTable">
                  <thead class="text-muted table-light">
                  <tr class="text-uppercase">
                    <template v-for="(item, index) in tableHeaders" :key="index">
                      <th v-show="item.visible">{{ item.label }}</th>
                    </template>
                    <th>
                      {{this.$t('base.operation')}}
                    </th>
                  </tr>
                  </thead>
                  <tbody class="list form-check-all">
                  <tr v-for="(item, index) in dataList" :key="index">
                    <template v-for="(titleItem, titleIdx) in tableHeaders" :key="titleIdx">
                      <td v-show="titleItem.visible">
                        <div v-if="titleItem.name === 'name'" class="d-flex align-items-center">
                          <show-avatar :img-src="item.logo" :title="item.name" size="xs" bg-class="bg-soft-info" text-class="text-info" class="me-2"></show-avatar>
                          <span class="text-wrap text-break" style="max-width: 150px;">{{ item[titleItem.name] }}</span>
                        </div>
                        <span v-else-if="['industry', 'attribute'].includes(titleItem.name) && item[titleItem.name]">
                          {{ $t(item[titleItem.name]) }}
                        </span>
                        <span v-else-if="titleItem.name === 'location'">
                          {{ locationTxt(item) }}
                        </span>
                        <span v-else-if="titleItem.name === 'address'" class="text-wrap text-break" style="max-width: 150px;">{{ item[titleItem.name] }}</span>
                        <span v-else-if="titleItem.name === 'register_status'">{{ item[titleItem.name] ? $t('page.registered') : $t('page.unregistered') }}</span>
                        <span v-else-if="titleItem.name === 'register_at'">{{ formatDatetime(item[titleItem.name]) }}</span>
                        <span v-else>{{ item[titleItem.name] }}</span>
                      </td>
                    </template>
                    <td>
                      <b-link :href="'/customer/' + item['id']"><i class="ri-eye-fill fs-3 text-primary me-3 cursor-pointer"></i></b-link>
                      <i class="ri-delete-bin-line fs-3 text-primary me-3 cursor-pointer" @click="deleteItem(item.id)"></i>
                    </td>
                  </tr>
                  </tbody>
                </table>
                <table-loading :count="count" :table-loaded="tableLoaded" :table-loading="tableLoading"></table-loading>
              </div>

            </div>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
    <Pagination
        v-if="tab_info_length"
        v-model:page="page"
        v-model:perPage="perPage"
        :pages="pages"
        :prePageOption="prePageOption"
        :tab_info_length="tab_info_length"
        @update:page="pageChange"
        @update:perPage="pageSizeChange"
        class="me-5 my-3"
    ></Pagination>
    <add-customer :title="this.$t('page.create')" ref="addCustomer" @refresh="_getFirstPage"></add-customer>
  </Layout>

</template>
